export default "__VITE_ASSET__Dd6DMQp2__"